module.exports = __webpack_public_path__ + "img/schematic.f98e1886.png";